import URL_REG_EXP from "../constants/urlRegx";

const isUrl = str => URL_REG_EXP.test(str);

const isUriEncoded = inUri => {
  // This is a bit of a kludge, but should be fit for purpose in the majority of cases
  // See discussion here:
  // https://stackoverflow.com/questions/17564837/how-to-know-if-a-url-is-decoded-encoded
  const uri = inUri || "";
  let result = false;
  try {
    // It may throw error when uri contains individual %
    result = uri !== decodeURI(uri);
  } catch (error) {
    result = false;
  }
  return result;
};

const encodeUri = uri => {
  return encodeURI(uri)
    .replace(/'/g, "%27")
    .replace(/@/g, "%40")
    .replace(/#/g, "\\%23")
    .replace(/\$/g, "%24")
    .replace(/&/g, "%26")
    .replace(/=/g, "%3D")
    .replace(/\+/g, "%2B")
    .replace(/;/g, "%3B")
    .replace(/,/g, "%2C")
    .replace(/\(/g, "\\(")
    .replace(/\)/g, "\\)");
};
const encodeUriIfRequired = uri => (isUriEncoded(uri) ? uri : encodeUri(uri));

export default {
  isUrl,
  isUriEncoded,
  encodeUri,
  encodeUriIfRequired
};
